import { render, staticRenderFns } from "./MailerDashboard.vue?vue&type=template&id=10cd64a2&scoped=true"
import script from "./MailerDashboard.vue?vue&type=script&lang=js"
export * from "./MailerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cd64a2",
  null
  
)

export default component.exports